import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="back"
//
// Makes a "back" link go through real history navigation — history.back(), which
// Turbo turns into a restoration visit and so restores the previous page's scroll
// position. A plain link to the referer (what `link_to :back` renders) is a fresh
// advance visit instead, which resets the scroll: pénible on the Tendances feed
// where returning from a product should land you exactly where you left off.
//
// Opt-in, et délibérément : history.back() va où pointe l'historique, ce qui est
// faux dès que la page peut être atteinte par une redirection après soumission de
// formulaire — l'entrée précédente est alors le formulaire qu'on vient de soumettre
// (ou, après une suppression, la ressource supprimée). À n'ajouter que pour revenir
// vers un feed paginé, sur une page qui n'est la cible d'aucune redirection de ce
// type. Partout ailleurs, un lien simple vers le chemin déclaré est à la fois juste
// et plus simple.
//
// The element's href is the fallback, followed when there is no in-app page to
// return to (direct entry via a shared link or SEO landing) or without JS — so it
// should point to an in-app destination (e.g. the feed), not off-site.
export default class extends Controller {
  navigate(event) {
    if (!this.#canGoBack) return

    event.preventDefault()
    window.history.back()
  }

  // Turbo records how many in-app advance visits led to this page in
  // history.state; a positive index means a previous page exists to restore.
  // Falls back to history.length for navigations Turbo didn't record.
  get #canGoBack() {
    const index = window.history.state?.turbo?.restorationIndex
    if (typeof index === "number") return index > 0

    return window.history.length > 1
  }
}
